export const getTrackingProductName = ({
  productName,
  variantName,
  annotation,
  additionalVariantInfo,
}: {
  productName: string;
  variantName?: string;
  annotation?: string;
  additionalVariantInfo?: string;
}) => `${productName} ${variantName || annotation || ''} ${additionalVariantInfo || ''}`.trimEnd();
